module.exports = __webpack_public_path__ + "img/test-tracking-icon.42bc8250.png";